import { render, staticRenderFns } from "./BehaviourTypeSelector.vue?vue&type=template&id=3b86763c&scoped=true&"
import script from "./BehaviourTypeSelector.vue?vue&type=script&lang=js&"
export * from "./BehaviourTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./BehaviourTypeSelector.vue?vue&type=style&index=0&id=3b86763c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86763c",
  null
  
)

export default component.exports